module.exports = __webpack_public_path__ + "static/media/banner-official-account.84108e15.png";